<button
  type="button"
  mat-icon-button
  class="notification-bell-button"
  [matMenuTriggerFor]="panel"
  (menuOpened)="onOpened()"
  (menuClosed)="onClosed()"
  [matTooltip]="'knowledge.notifications.bell' | translate"
  [attr.aria-label]="bellLabelKey() | translate: bellLabelParams()"
  data-test="notification-bell">
  <span class="notification-bell-glyph material-symbols-outlined" [class.notification-bell-glyph--unread]="hasUnread()">notifications</span>

  @if (!badgeHidden()) {
    <span class="notification-bell-count" aria-hidden="true">{{ badgeLabel() }}</span>
  }
</button>

<!-- Announces a count that changes while the reader is elsewhere, and gives the E2E suite a stable hook. -->
<span class="notification-bell-live" role="status" aria-live="polite" aria-atomic="true" data-test="notification-bell-count">{{ unreadCount() }}</span>

<mat-menu #panel="matMenu" class="notification-panel" backdropClass="notification-panel-backdrop" xPosition="before" yPosition="below">
  <!-- matMenuContent, not bare projection: mat-menu renders content inside its own ng-template, so a panel
       placed directly here would be built with the top bar on every page load and read the feed at boot. -->
  <ng-template matMenuContent>
    <app-knowledge-notification-panel
      [state]="panelState()"
      (activated)="onActivated($event)"
      (markAllRequested)="onMarkAll()"
      (retryRequested)="loadFeed()"
      (pushToggled)="onPushToggle()"></app-knowledge-notification-panel>
  </ng-template>
</mat-menu>
